































































































































































































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import Form from "@/components/Form/Form.vue";
import {Action, Getter, Mutation} from "vuex-class";
import Input from "@/components/Form/elements/Input.vue";
import Select from "@/components/Form/elements/Select.vue";
import AuthService from "@/service/AuthService";
import AppConfig from "@/config/AppConfig";
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import Modal from "@/components/Modal/Modal.vue";
import ModalCard from "@/components/Modal/ModalCard.vue";
import ITimeTrackingRecord from "@/models/TimeTracking/ITimeTrackingRecord";
import ITimeTrackingTask from "@/models/TimeTracking/ITimeTrackingTask";

const NAMESPACE_TIME_TRACKING_TASKS: string = 'timeTrackingTasks';
const NAMESPACE_TIME_TRACKING_RECORDS: string = 'timeTrackingRecords';

const RESOURCE_TIME_TRACKING_TASKS: string = 'tt/task';
const RESOURCE_TIME_TRACKING_RECORDS: string = 'tt/records';


@Component({
  components: {ModalCard, Modal, Select, Input, Form, VueCtkDateTimePicker}
})
export default class TimeTrackingNewTask extends Vue {
  public name: string = "TimeTrackingNewTask";

  @Action('loadDropdownData', {namespace: NAMESPACE_TIME_TRACKING_TASKS}) loadDropdownData: any;

  @Action('createItem', {namespace: NAMESPACE_TIME_TRACKING_TASKS}) createItem: any;

  @Getter('getDropdownData', {namespace: NAMESPACE_TIME_TRACKING_TASKS}) dropdownData: any;
  @Getter('getValidationErrors', {namespace: NAMESPACE_TIME_TRACKING_TASKS}) validationErrors: any;


  // @Mutation('ADD_RECORD_ON_TOP', {namespace: NAMESPACE_TIME_TRACKING_TASKS}) addRecordOnTop: any;
  // @Mutation('SET_RUNNING_RECORD', {namespace: NAMESPACE_TIME_TRACKING_TASKS}) setRunningRecord: any;

  @Prop({required: true})
  public visible!: boolean;

  private task_title?: string = '';
  private task_estimated_time?: number = 0;
  private task_deadline?: string = '';

  private start?: string = '';
  private stop?: string = '';
  private client_id?: number = 1;
  private brand_id?: number = 2;
  private project_id?: number = 1;
  private newProject?: string = '';
  private newBrand?: string = '';

  private brandBudgetFieldActive: boolean = false;
  private dropdownOptions: any = {};

  private authService: any = new AuthService();


  private currentUserId: number = this.authService.getUserId();

  private inputSuggestions: any = {
    text: []
  }


  @Watch('dropdownData', {immediate: true, deep: true})
  onDropdownDataChange() {

    if (this.dropdownData) {

      this.dropdownOptions = [];
      Object.keys(this.dropdownData).forEach((key) => {

        this.dropdownOptions[key] = [];

        this.dropdownData[key].forEach((item) => {

          switch (key) {

            case 'tasks':

              this.dropdownOptions[key].push({
                text: item.name,
                value: item.id,
                htmlText: item.name,
              });

              break;

            case 'brands':

              if (item.time_tracking_client_id === this.client_id) {

                this.dropdownOptions[key].push({
                  text: item.name,
                  value: item.id,
                  htmlText: item.name,
                });

              }

              break;

            case 'projects':

              if (item.time_tracking_brand_id === this.brand_id) {

                this.dropdownOptions[key].push({
                  text: item.name,
                  value: item.id,
                  htmlText: item.name,
                });

              }

              break;

            default:

              this.dropdownOptions[key].push({
                text: item.name,
                value: item.id,
                htmlText: item.name,
              });


          }

        });
      });

    }

  }

  @Watch('brand_id', {immediate: false})
  private onBrandSelectionChanged() {

   // this.brandBudgetFieldActive = this.brandHasBudget(this.brand_id ?? -1);

  }

  @Watch('client_id', {immediate: true})
  private onClientIdChanged(): void {

    this.onDropdownDataChange();

  }


  private brandHasBudget(brandId: number) {

    if (brandId === -1) {

      return false;

    }

    let brands: any = [];

    brands = this.dropdownData['brands'].filter((brand: any) => {
      return brand.id === this.brand_id;
    });

    return !!(brands[0].hasOwnProperty('budget_hours') && brands[0].budget_hours);

  }

  private get newItem(): ITimeTrackingTask {

    return {
      title: this.task_title,
      estimated_time_secs: this.task_estimated_time,
      deadline: this.task_deadline,
      client_id: this.client_id,
      brand_id: this.brand_id,

    };

  }

  private getInputDataList(fieldName: string) {

    return this.inputSuggestions[fieldName];

  }


  private onNewTask(): void {

    this.createItem({resource: RESOURCE_TIME_TRACKING_TASKS, data: this.newItem})

        .then((response) => {

          this.$emit('active-changed', false);

        })

  }

  private onNewProjectInputChanged() {

    this.project_id = 0;

  }

  private onProjectSelectChanged(e: Event) {

    this.newProject = '';

  }

  private onNewBrandInputChanged() {

    this.brand_id = 0;

  }

  private onBrandSelectChanged(e: Event) {

    this.newBrand = '';

    this.brandBudgetFieldActive = this.brandHasBudget(this.brand_id ?? -1);

  }

  private onTaskSelectChanged(e: Event) {

    // removed console_log

  }


  private initBroadcastListener(): void {

    this.$echo.channel('TimeTracking')
        .listen('TimeTracking\\UserHasCreatedNewTask', (e) => {

          // removed console_log
          // this.addTaskOnTop(e.timeTracking);

        });


  }


  mounted() {

    this.initBroadcastListener();
    this.loadDropdownData({resource: RESOURCE_TIME_TRACKING_TASKS});


  }


}
